<template>
  <router-view></router-view>
</template>

<script>
import { useStore } from 'vuex'
import * as VueI18n from 'vue-i18n'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'

function prepareCustomerTypes(store, t) {
  let customerTypes = []

  customerTypes.push({
    id: 1,
    name: t('privatePage.customerType_supplier')
  })

  customerTypes.push({
    id: 2,
    name: t('privatePage.customerType_reseller')
  })

  customerTypes.push({
    id: 3,
    name: t('privatePage.customerType_customer')
  })

  store.dispatch(
    'userGroupsModule/addCustomerTypeTranslations',
    customerTypes
  )
}
export default {
  setup(props, context) {
    let that = {...context}
    const { t, locale } = VueI18n.useI18n()
    const store = useStore()
    let companyName = window.location.search
      .replace('/', '')
      .replace('?', '')
      .replace('#', '')

    // Setup application insights
    const isProd = !!((window.location && window.location.href) || '').includes('psytest.se')
    const insightsKey = isProd ? process.env.APP_INSIGHTS_INSTRUMENTATION_KEY_PROD : process.env.APP_INSIGHTS_INSTRUMENTATION_KEY_DEV
    if (insightsKey) {
      const appInsights = new ApplicationInsights({ config: {
        instrumentationKey: insightsKey
      } })
      appInsights.loadAppInsights()
    }

    if (companyName.length > 0) {
      store.dispatch('setSiteCompanyName', companyName)
      store.dispatch('getSiteCompanyLogo', companyName).then(logo => {
        store.dispatch('setSiteCompanyLogo', logo)
      })
    }

    let defaultCulture = {
      countryCode: 'us',
      langCode: 'en',
      languageId: 'en-US'
    }

    let selectedLangCode = 'en'

    store
      .dispatch('getLanguages')
      .then(languages => {
        var language = navigator.language.substring(0, 2)

        languages.forEach(element => {
          if (element.langCode === language) {
            selectedLangCode = element.langCode
          }
        })

        languages.forEach(element => {
          that.language = element.langCode
          element.langName = t(element.langCode)

          if (element.langCode === defaultCulture.langCode) {
            store.dispatch('setDefaultCulture', element)
          }

          if (element.langCode === selectedLangCode) {
            store.dispatch('setSelectedCulture', element)
          }
        })

        that.language = selectedLangCode
        locale.value = selectedLangCode
        prepareCustomerTypes(store, t)
        store.dispatch('setAppLanguages', languages)
      })
      .catch(() => {
        that.language = 'en'
        locale.value = 'en'
        prepareCustomerTypes(store, t)
        store.dispatch('setDefaultCulture', defaultCulture)
        store.dispatch('setSelectedCulture', defaultCulture)
      })

    store.dispatch('getAppSettings')
  }
}
</script>

<style lang="scss">
* {
  font-family: Arial, Helvetica, Sans-Serif;
  font-size: 14px;
  font-weight: normal;
  color: #333333;
}
sup {
  font-size: 15px !important;
  vertical-align: text-top;
  line-height: 0;
  font-weight: bold;
  color: #333333;
}
h1 {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-weight: bold;
  color: inherit;
  margin: 2rem 0rem 2rem 0rem;
}

.h1-test {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: bold;
}
h2 {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: inherit;
}
h3 {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: bold;
  color: inherit;
}
h4 {
  font-family: Arial, Helvetica, sans-serif;
  color: #123a77;
}
h5 {
  font-family: Arial, Helvetica, sans-serif;
  color: #123a77;
}
body {
  margin: 0px;
  min-height: 100vh;
}

a,
a:visited {
  color: #0d6efd;
}
a:hover {
  color: #0000cc;
}

strong {
  font-weight: bold;
}

.mainSection {
  margin-top: 30px;
  margin-left: 20px;
}

.fieldHeader {
  font-weight: bold;
}

.hiddenTableHeader {
  visibility: hidden;
  line-height: 0px;
  margin: 0px;
  padding: 0px;
}

.rightAlignedField {
  text-align: right;
}

.tableCellMinSize {
  width: 1%;
}

.tableCellMaxSize {
  width: 100%;
}

.modalHeader {
  font-size: 18pt;
}

.bg-secondary {
  background-color: #404041 !important;
  padding: 20px;
}

.btn-primary {
  background-color: #1bc2f3 !important;
  border-color: #1bc2f3 !important;
  color: #fff;

  & > * {
    color: #fff;
  }
}

.btn-primary:hover {
  background-color: #199ec5 !important;
  border-color: #199ec5 !important;
}

.btn-danger {
  color: #fff !important;
  & > * {
    color: #fff !important;
  }
}

.btn-outline-primary {
  border-color: #1bc2f3 !important;
  color: #1bc2f3;
}

.btn-outline-primary:hover {
  background-color: #1bc2f3 !important;
  border-color: #1bc2f3 !important;
  color: #fff !important;
}

.btn-secondary {
  color: #fff !important;
  background-color: #1bc2f3 !important;
  border-color: #1bc2f3 !important;

  & > * {
    color: #fff !important;
  }
}

.btn-secondary:hover {
  background-color: #199ec5 !important;
  border-color: #199ec5 !important;
}

.btn-success {
  color: #404041 !important;
  background-color: #eaeaea !important;
  border-color: #eaeaea !important;
}

.btn-outline-success {
  border-color: #eaeaea !important;
}

.btn-outline-success:hover {
  background-color: #eaeaea !important;
  border-color: #eaeaea !important;
}

.btn-info {
  color: #fff !important;
  background-color: #1bc2f3 !important;
  border-color: #1bc2f3 !important;
}

.btn-info:hover {
  color: #fff !important;
  background-color: #1aaeda !important;
  border-color: #1aaeda !important;
}

.col-content {
  padding-left: 0px;
  padding-right: 0px;
}

.rowHeader_first {
  margin: 0px 0px 5px 0px;
}

.rowHeader {
  margin: 20px 0px 5px 0px;
}

.list-group-item {
  padding: 0.75rem 1rem;
}

.list-group-item:hover {
  color: #fff;
  background-color: #1bc2f3 !important;
}

.card .list-group-item:hover {
  color: #333333 !important;
  background-color: #fff !important;
}

.jumbotron {
  background-color: #f0f1f2 !important;
}

.ql-editor {
  background-color: #fff !important;
}

table.b-table > tbody > tr.b-table-details > td {
  background-color: #fff !important;
  padding: 0px !important;
}

.table-striped tbody tr:nth-of-type(even) {
  background-color: #e9e9e9;
}

.btn-outline-secondary {
  padding: 0.75rem 3rem;
  border: 1px solid rgba(0, 0, 0, 0.125) !important;
}

.btn-outline-secondary:active,
.btn-outline-secondary:focus,
.btn-outline-secondary:visited,
.btn-outline-secondary:hover {
  background-color: #1bc2f3 !important;
  color: #fff !important;
  border: 1px solid rgba(0, 0, 0, 0.125) !important;
}

.btn-outline-secondary:not(:disabled):not(.disabled).active {
  background-color: #1bc2f3 !important;
  color: #fff !important;
}

.btn-outline-secondary:hover span,
.btn-outline-secondary:not(:disabled):not(.disabled).active span {
  color: #fff !important;
}

.btn-link,
.btn-link .btn-content {
  color: #0d6efd;
}
.btn-link:hover,
.btn-link .btn-content:hover {
  text-decoration: underline;
}
table td {
  vertical-align: middle !important;
}
td .custom-control-inline {
  margin-right: 0px;
}
.table thead th {
  border-bottom: none;
  border-top: none;
}
.table .table tr {
  background-color: #fff !important;
}
.table .table {
  border: 1px solid #dee2e6 !important;
}
.nav-tabs .nav-link {
  color: #333333 !important;
}
// CSS for the Status Table used in StatusPage.vue.
.statusTable thead th {
  font-weight: bold !important;
}
.statusTable td {
  border-top: none !important;
}
.image-bank-image img {
  height: 70px !important;
  width: 60px !important;
}
.user-card .card-body {
  padding: 1rem;
}
.user-card .table {
  border: none !important;
}
table td {
  border-top: none !important;
}
table th {
  font-weight: bold;
}
// CSS for data tables
.vue3-easy-data-table table {
  --easy-table-body-row-background-color: rgba(0,0,0,.05);
  --easy-table-body-even-row-background-color: #e9e9e9;
}
</style>
